"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_native_1 = require("react-native");

var styled_components_1 = __importStar(require("styled-components"));

var Icon_1 = __importStar(require("../Icon/Icon"));

var styled_1 = require("../styled");

var defaultDuration = 300;

var ScrollDownAnimation =
/** @class */
function (_super) {
  __extends(ScrollDownAnimation, _super);

  function ScrollDownAnimation(props) {
    var _this = _super.call(this, props) || this;

    _this.animationTop = new react_native_1.Animated.Value(0);
    _this.animationMiddle = new react_native_1.Animated.Value(0);
    _this.animationBottom = new react_native_1.Animated.Value(0);
    return _this;
  }

  ScrollDownAnimation.prototype.componentDidMount = function () {
    this.jump();
  };

  ScrollDownAnimation.prototype.jump = function () {
    react_native_1.Animated.loop(react_native_1.Animated.sequence([react_native_1.Animated.timing(this.animationTop, {
      duration: defaultDuration,
      toValue: 1,
      useNativeDriver: true
    }), react_native_1.Animated.timing(this.animationMiddle, {
      duration: defaultDuration,
      toValue: 1,
      useNativeDriver: true
    }), react_native_1.Animated.timing(this.animationBottom, {
      duration: defaultDuration,
      toValue: 1,
      useNativeDriver: true
    }), react_native_1.Animated.timing(this.animationTop, {
      duration: defaultDuration,
      toValue: 0,
      useNativeDriver: true
    }), react_native_1.Animated.timing(this.animationMiddle, {
      duration: defaultDuration,
      toValue: 0,
      useNativeDriver: true
    }), react_native_1.Animated.timing(this.animationBottom, {
      duration: defaultDuration,
      toValue: 0,
      useNativeDriver: true
    })]), {
      iterations: -1
    }).start();
  };

  ScrollDownAnimation.prototype.render = function () {
    var theme = this.props.theme;
    return react_1.default.createElement(styled_1.ColumnCentered, null, react_1.default.createElement(react_native_1.Animated.Text, {
      style: {
        opacity: this.animationTop
      }
    }, react_1.default.createElement(Icon_1.default, {
      size: Icon_1.IconSizeEnum.medium,
      name: "chevron-down",
      color: theme.colors.dark
    })), react_1.default.createElement(ContainerWithOffset, null, react_1.default.createElement(react_native_1.Animated.Text, {
      style: {
        opacity: this.animationMiddle
      }
    }, react_1.default.createElement(Icon_1.default, {
      size: Icon_1.IconSizeEnum.medium,
      name: "chevron-down",
      color: theme.colors.dark
    }))), react_1.default.createElement(ContainerWithOffset, null, react_1.default.createElement(react_native_1.Animated.Text, {
      style: {
        opacity: this.animationBottom
      }
    }, react_1.default.createElement(Icon_1.default, {
      size: Icon_1.IconSizeEnum.medium,
      name: "chevron-down",
      color: theme.colors.dark
    }))));
  };

  return ScrollDownAnimation;
}(react_1.default.Component);

exports.ScrollDownAnimation = ScrollDownAnimation;
var ContainerWithOffset = styled_components_1.default(react_native_1.Text)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin-top: -24px;\n"], ["\n    margin-top: -24px;\n"])));
exports.default = styled_components_1.withTheme(ScrollDownAnimation);
var templateObject_1;